var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLeftbutton = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 24,
  width: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "m16 4-9 8 9 8"
})));
export default SvgLeftbutton;